<script setup lang="ts">
import { UISpin } from "@gohighlevel/ghl-ui";
import { onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { BlogSiteService } from "./services";
import { FunnelService } from "./services/FunnelService";
import { useAppStore } from "./store/app";


const store = useAppStore();
const { t } = useI18n();
const showLoader = ref(true);

const checkMigrationStatus = async () => {
  try {
    showLoader.value = true;
    const { data } = await BlogSiteService.getMigrationStatus(store.locationId);
    const isMigrated = data?.isMigrated ?? true;
    if (isMigrated) {
      showLoader.value = false;
      return;
    }
    const body = {
      name: t('common.defaultBlogSite'),
      type: "blog",
      locationId: store.locationId,
      urlSlug: "home-blog",
    };
    let { data: as } = await FunnelService.createBlog(body);

    const blog = {
      funnelId: as.funnelId,
      locationId: store.locationId,
    };
    await BlogSiteService.migrateBlogPost(blog);
    showLoader.value = false;
  } catch (err) {
    console.error(err);
    showLoader.value = false;
  }
};

onMounted(() => {
  checkMigrationStatus();
});
</script>
<template>
  <div v-if="showLoader" class="flex h-screen p-80">
    <div class="m-auto">
      <UISpin size="large" />
    </div>
  </div>
  <div v-else>
    <RouterView />
  </div>
</template>
